import {
  OrganizationAccountAddPath,
  OrganizationAccountDashboardPath,
  OrganizationAccountDevicesPath,
  OrganizationAccountEditPath,
  OrganizationAccountPath,
  OrganizationAccountReportsPath,
  OrganizationAccountVaultsPath,
  OrganizationAccountsAliasesPath,
  OrganizationAccountsPath,
  OrganizationAccountsVaultsAdminPath,
  OrganizationAccountsVaultsBulkEditAdminPath,
  OrganizationAddPath,
  OrganizationDashboardPath,
  OrganizationDetailsPath,
  OrganizationEditPath,
  OrganizationPath,
  OrganizationReportsActiveUsersPath,
  OrganizationReportsEncryptsDecryptsPath,
  OrganizationReportsInstallationsPath,
  OrganizationReportsNewAccountsPath,
  OrganizationReportsPath,
  OrganizationReportsUsageAndAccessPath,
  OrganizationReportsUsersPath,
  OrganizationSettingsPath,
  OrganizationsPath
} from '../paths';
import React, { lazy } from 'react';
import {
  faBuilding,
  faBuildings,
  faGrid,
  faLaptopMobile
} from '@fortawesome/pro-regular-svg-icons';
import { faChartPie, faGear, faUsers } from '@fortawesome/free-solid-svg-icons';

import AccountBreadcrumb from '../../components/Navigation/Breadcrumbs/AccountBreadcrumb';
import AuthRoute from '../AuthRoute';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IBreadcrumbRouteProps } from '../types';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import OrganizationBreadcrumb from '../../components/Navigation/Breadcrumbs/OrganizationBreadcrumb';
import { faVault } from '@fortawesome/pro-solid-svg-icons';
import strings from '../../strings';

const Account = lazy(() => import('../../pages/Account'));
const AccountDevices = lazy(() => import('../../pages/Account/Devices'));
const AccountVaultsBulkEdit = lazy(
  () => import('../../pages/Profile/Vaults/BulkEdit')
);
const AccountVaults = lazy(() => import('../../pages/Profile/Vaults'));
const AccountReports = lazy(() => import('../../pages/Account/Reports'));
const AccountAliases = lazy(() => import('../../pages/Account/Aliases'));
const AccountEdit = lazy(() => import('../../pages/Account/Edit'));
const AccountDashboard = lazy(() => import('../../pages/Profile/Dashboard'));
const OrganizationDetails = lazy(
  () => import('../../pages/Organization/Details')
);
const OrganizationAccounts = lazy(
  () => import('../../pages/Organization/Accounts')
);
const OrganizationDashboard = lazy(
  () => import('../../pages/Organization/Dashboard')
);
const OrganizationEdit = lazy(
  () => import('../../pages/Organization/Details/Edit')
);
const OrganizationReports = lazy(
  () => import('../../pages/Organization/Reports')
);
const UsageAndAccess = lazy(
  () => import('../../pages/Organization/Reports/ReportTypes/Users')
);
const EncryptsDecrypts = lazy(
  () => import('../../pages/Organization/Reports/ReportTypes/EncryptedReports')
);
const Installations = lazy(
  () =>
    import('../../pages/Organization/Reports/ReportTypes/InstallationsReports')
);
const NewAccounts = lazy(
  () =>
    import('../../pages/Organization/Reports/ReportTypes/RegistrationReports')
);
const ActiveUsers = lazy(
  () =>
    import('../../pages/Organization/Reports/ReportTypes/ActiveUsersReports')
);

const OrganizationSettings = lazy(
  () => import('../../pages/Organization/Settings')
);
const Organizations = lazy(() => import('../../pages/Organizations'));

export const childProfileTabs = [
  {
    path: OrganizationAccountPath,
    title: strings.navigationUserProfileAccountTitle
  },
  {
    path: OrganizationAccountsAliasesPath,
    title: strings.navigationUserProfileAliasesTitle
  }
];

export const childReportTabs = [
  {
    path: OrganizationAccountReportsPath,
    title: strings.navigationUserProfileEncryptsAndDecryptsTitle
  }
];

export const AccountTabs = [
  {
    path: OrganizationAccountDashboardPath,
    title: strings.navigationAdminOrganizationDashboardTitle,
    icon: <FontAwesomeIcon icon={faGrid as IconProp} fontSize={18} />
  },
  {
    path: '',
    title: strings.navigationAdminAccountTitle,
    child: childProfileTabs,
    icon: <FontAwesomeIcon icon={faUsers as IconProp} fontSize={18} />
  },
  {
    path: OrganizationAccountDevicesPath,
    title: strings.navigationAdminAccountDevicesTitle,
    icon: <FontAwesomeIcon icon={faLaptopMobile as IconProp} fontSize={18} />
  },
  {
    path: OrganizationAccountVaultsPath,
    title: strings.navigationAdminAccountVaultsTitle,
    icon: <FontAwesomeIcon icon={faVault as IconProp} fontSize={18} />
  },
  {
    path: '',
    title: strings.navigationAdminAccountReportsTitle,
    child: childReportTabs,
    icon: <FontAwesomeIcon icon={faChartPie as IconProp} fontSize={18} />
  }
];

export const ChildReportTabs = [
  {
    path: OrganizationReportsActiveUsersPath,
    title: strings.navigationAdminOrganizationsActiveUsersTitle
  },
  {
    path: OrganizationReportsEncryptsDecryptsPath,
    title: strings.navigationUserProfileEncryptsAndDecryptsTitle
  },
  {
    path: OrganizationReportsInstallationsPath,
    title: strings.navigationAdminOrganizationsInstallationsTitle
  },
  {
    path: OrganizationReportsNewAccountsPath,
    title: strings.navigationAdminOrganizationsNewAccountsTitle
  },
  {
    path: OrganizationReportsUsageAndAccessPath,
    title: strings.navigationAdminOrganizationsUsegeAndAccessTitle
  }
];

export const OrganizationTabs = [
  {
    path: OrganizationDashboardPath,
    title: strings.navigationAdminOrganizationDashboardTitle,
    icon: <FontAwesomeIcon icon={faGrid as IconProp} fontSize={18} />
  },
  {
    exact: true,
    path: OrganizationDetailsPath,
    title: strings.navigationAdminOrganizationTitle,
    icon: <FontAwesomeIcon icon={faBuilding as IconProp} fontSize={18} />
  },
  {
    path: OrganizationAccountsPath,
    title: strings.navigationAdminOrganizationAccountsTitle,
    icon: <FontAwesomeIcon icon={faUsers as IconProp} fontSize={18} />
  },
  {
    path: OrganizationAccountsVaultsAdminPath,
    title: strings.navigationAdminAccountVaultsTitle,
    icon: <FontAwesomeIcon icon={faVault as IconProp} fontSize={18} />
  },
  {
    path: '',
    title: strings.navigationAdminOrganizationReportsTitle,
    child: ChildReportTabs,
    icon: <FontAwesomeIcon icon={faChartPie as IconProp} fontSize={18} />
  },
  {
    path: OrganizationSettingsPath,
    title: strings.navigationAdminOrganizationSettingsTitle,
    icon: <FontAwesomeIcon icon={faGear as IconProp} fontSize={18} />
  }
];

export const OrganizationsTabs = [
  {
    path: OrganizationsPath,
    title: strings.navigationAdminOrganizationsTitle,
    icon: <FontAwesomeIcon icon={faBuildings as IconProp} fontSize={18} />
  }
];

const adminRoutes: IBreadcrumbRouteProps[] = [
  {
    children: () => (
      <AuthRoute>
        <Organizations />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationsPath,
    tabs: OrganizationsTabs
  },
  {
    children: () => (
      <AuthRoute>
        <OrganizationEdit />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAddPath
  },
  {
    breadcrumb: OrganizationBreadcrumb,
    children: () => (
      <AuthRoute>
        <OrganizationDetails />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <OrganizationDetails />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationDetailsPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <OrganizationEdit />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationEditPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <OrganizationDashboard />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationDashboardPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <OrganizationReports />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationReportsPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <UsageAndAccess />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationReportsUsageAndAccessPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <EncryptsDecrypts />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationReportsEncryptsDecryptsPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <Installations />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationReportsInstallationsPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <NewAccounts />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationReportsNewAccountsPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <ActiveUsers />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationReportsActiveUsersPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <OrganizationAccounts />
      </AuthRoute>
    ),
    path: OrganizationReportsUsersPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <OrganizationSettings />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationSettingsPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <OrganizationAccounts />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountsPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountVaults />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountsVaultsAdminPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountVaultsBulkEdit />
      </AuthRoute>
    ),
    path: OrganizationAccountsVaultsBulkEditAdminPath,
    tabs: OrganizationTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountEdit />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountAddPath,
    tabs: OrganizationTabs
  },
  {
    breadcrumb: AccountBreadcrumb,
    children: () => (
      <AuthRoute>
        <Account />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountPath,
    tabs: AccountTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountAliases />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountsAliasesPath,
    tabs: AccountTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountDevices />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountDevicesPath,
    tabs: AccountTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountVaults />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountVaultsPath,
    tabs: AccountTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountReports />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountReportsPath,
    tabs: AccountTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountDashboard />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountDashboardPath,
    tabs: AccountTabs
  },
  {
    children: () => (
      <AuthRoute>
        <AccountEdit />
      </AuthRoute>
    ),
    exact: true,
    path: OrganizationAccountEditPath,
    tabs: AccountTabs
  }
];

export default adminRoutes;
